export default axiosInstance => ({
  /**
   * list attributes Mirakl
   * @return {Promise} retour axios
   */
  async listMiraklAttributes(params) {
    return await axiosInstance.get(`/mirakl_attributes`, { params });
  },

  /**
   * list attributes Mirakl of type LIST (sorry quick workaround to make the feature work with Nicolas Autocomplete)
   * @return {Promise} retour axios
   */
  async listMiraklAttributesTypeList(params) {
    params.type = "LIST";
    return await axiosInstance.get(`/mirakl_attributes`, { params });
  },

  /**
   * add attributes Mirakl
   * @return {Promise} retour axios
   */
  async addAttribute(params) {
    return axiosInstance.post("/mirakl_attributes", { ...params });
  },
  /**
   * delete  Mirakl
   * @return {Promise} retour axios
   */
  async deletAttribute(id) {
    return axiosInstance.delete(`/mirakl_attributes/${id}`);
  },
  /**
   * edit attributes Mirakl
   * @return {Promise} retour axios
   */
  async editAttribute(id, form) {
    return axiosInstance.put(`/mirakl_attributes/${id}`, form);
  },

  /**
   * get attributes Mirakl
   * @return {Promise} retour axios
   */
  async getMiraklAttribute(id) {
    return axiosInstance.get(`/mirakl_attributes/${id}`);
  },
  /**
   * post attributes csv
   * @return {Promise} retour axios
   */
  async importAttributesCsv(params) {
    let formData = new FormData();
    formData.append("file", params);
    return await axiosInstance.post("/mirakl_attributes/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
});
